import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import type { RouteComponentProps } from 'react-router';

import {
  TXTCLI_Create_Your_PokerStars_Account,
  TXTCLI_Step_N0_of_N1
} from './RegistrationHeader.messages.json';
import styles from './RegistrationHeader.scss';

export enum Route {
  Default = '/auth/registration',
  BankID = '/auth/registration/bankid'
}

const RouteMap: Record<string, number> = {
  [Route.Default]: 2,
  [Route.BankID]: 1
};

const RegistrationHeader: React.FC<RouteComponentProps> = ({ match: { path, isExact } }) => {
  const bankID = useFeature(FeatureFlag.BankID);
  const step = bankID ? RouteMap[path] : RouteMap[path] - 1;
  const end = bankID ? 3 : 2;

  return (
    <span className={styles.center}>
      <Translation {...TXTCLI_Create_Your_PokerStars_Account} />
      <Translation {...TXTCLI_Step_N0_of_N1} values={{ 0: isExact ? step : end, 1: end }}>
        {(text) => (
          <span>
            &nbsp;(
            {text})
          </span>
        )}
      </Translation>
    </span>
  );
};

export default RegistrationHeader;
